export default __webpack_public_path__ + "1f09558bb060899d87080c06da47fed9.png";